var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"7.16162","width":"1.18847","height":"10.102","transform":"rotate(45.1496 7.16162 0)","fill":"#7D7D7D","key":0}),React.createElement("rect",{"x":"0.000488281","y":"7.12447","width":"1.18847","height":"10.102","transform":"rotate(-44.8504 0.000488281 7.12447)","fill":"#7D7D7D","key":1})]);
}

Arrow.defaultProps = {"width":"8","height":"15","viewBox":"0 0 8 15","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
